import { useAnalytics } from "@codat/analytics";
import { PropsWithChildren } from "react";

import styles from "./AuthPage.module.css";
import { CodatLogo } from "./logos/codatLogo";

const currentYear = new Date().getFullYear();

const AuthPage: React.FC<PropsWithChildren> = ({ children }) => {
  const { sendEvent } = useAnalytics();

  return (
    <main className={styles.AuthPageContainer}>
      <div className={styles.header}>
        <CodatLogo />
      </div>
      {children}

      <div className={styles.footer}>
        <span>{`© ${currentYear} Codat Limited`}</span>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span>
          <a
            href="https://www.codat.io/contact/"
            target="_blank"
            rel="noreferrer"
            onClick={() => sendEvent("Contact Link - Click")}
            data-testid="contact-link"
          >
            Contact
          </a>
        </span>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span>
          <a
            href="https://www.codat.io/privacy-policy/"
            target="_blank"
            rel="noreferrer"
            onClick={() => sendEvent("Privacy Link - Click")}
            data-testid="privacy-link"
          >
            Privacy
          </a>
        </span>
      </div>
    </main>
  );
};

export default AuthPage;
